// VoiceSpectrum.Web.T2 - components/ConfirmDelete - v1.0 (12.3.12)
// v12.3.12 (#323): ONE delete confirmation for the whole tenant surface. Tushar, 12.3.11 verification:
// "delete should always ask for confirmation. it should never delete with just click of a button. this should
// be part of our standard and we have patter that we show to type name before delete enables."
//
// The pattern was already in use in two places (card deletes since #186, drawer deletes since #238-D) and
// nowhere else, so a Quick Answer or a Knowledge Base document went on a single click of a trash icon. This is
// that pattern extracted, so applying it somewhere new is an import rather than a re-implementation.
//
// The gate is deliberately typing the NAME, not an "Are you sure?" - the second is a reflex click, the first
// cannot be done by accident.
import { useEffect, useRef, useState } from 'react';

export function ConfirmDelete({
  name,
  what,
  consequence,
  busy,
  onCancel,
  onConfirm,
  confirmLabel = 'Delete',
}: {
  /** The exact text the person must type back. Usually the item's own title. */
  name: string;
  /** What is being deleted, in the person's words: "Quick Answer", "document", "field". */
  what: string;
  /** What actually happens - be specific about anything that is NOT undone. */
  consequence?: string;
  busy?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  confirmLabel?: string;
}) {
  const [typed, setTyped] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => { inputRef.current?.focus(); }, []);
  const matched = typed.trim().toLowerCase() === (name ?? '').trim().toLowerCase();
  return (
    <div className="settings-modal-backdrop" role="presentation" onClick={busy ? undefined : onCancel}>
      <section className="settings-modal" role="dialog" aria-modal="true" aria-labelledby="cdel-title"
        onClick={(e) => e.stopPropagation()}>
        <h2 id="cdel-title">Delete this {what}?</h2>
        <p>
          <b>{name}</b>{consequence ? ` — ${consequence}` : ''}
        </p>
        <p>Type the {what}&rsquo;s name to confirm.</p>
        <input
          ref={inputRef}
          className="settings-input"
          value={typed}
          placeholder={name}
          onChange={(e) => setTyped(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && matched && !busy) onConfirm(); }}
        />
        <div className="settings-actions">
          <button type="button" className="settings-secondary" onClick={onCancel} disabled={busy}>Cancel</button>
          <button type="button" className="settings-danger" onClick={onConfirm} disabled={!matched || busy}>
            {busy ? 'Deleting…' : confirmLabel}
          </button>
        </div>
      </section>
    </div>
  );
}

export default ConfirmDelete;
